<template>
<div>
  <div v-if="review.checkForPhotos" class="loading-container">
    <span class="spinner-border spinner-border-sm"></span>
    <span class="ms-2">Loading images...</span>
  </div>
  <div v-if="allPhotos.length" class="photos-container">
    <div class="image-set-scroll">
      <CommentPhoto v-for="(photo, index) in previewPhotos"
        :key="photo.id"
        :photo="photo"
        :index="index"
        :all-photos="allPhotos"
        :title="`${review.user.displayName || 'User'} photo ${index + 1}`" />

      <button class="view-more-button"
        @click="openLightboxAtFirstHidden"
        v-if="showMoreButton">
        <span class="view-more-text">View<br>more ({{allPhotos.length}})</span>
      </button>
    </div>
  </div>
</div>
</template>

<script>
import CommentPhoto from './CommentPhoto.vue';

export default {
  data() {
    return {
      previewPhotoCount: 4,
    };
  },
  components: {
    CommentPhoto,
  },
  props: {
    review: {
      type: Object,
      required: true,
    },
  },
  computed: {
    showMoreButton() {
      return this.allPhotos.length > this.previewPhotoCount;
    },
    allPhotos() {
      return this.review.images || [];
    },
    previewPhotos() {
      return this.allPhotos.slice(0, this.previewPhotoCount);
    },
  },
  methods: {
    openLightboxAtFirstHidden() {
      // Trigger click on the first hidden photo to open lightbox at that position
      const firstHiddenIndex = this.previewPhotoCount;
      const firstHiddenPhoto = this.allPhotos[firstHiddenIndex];
      if (firstHiddenPhoto) {
        // Find the corresponding link and click it
        const links = document.querySelectorAll(`a[data-lightbox="images"][href="${firstHiddenPhoto.file.lgUrl}"]`);
        if (links.length > 0) {
          links[0].click();
        }
      }
    },
  },
};
</script>

<style scoped>
.loading-container {
  padding: 1rem 0;
  display: flex;
  align-items: center;
}

.photos-container {
  margin: 0.5rem 0;
  width: 100%;
  overflow: hidden;
}

.image-set-scroll {
  display: flex;
  gap: 0.5rem;
  overflow-x: auto;
  overflow-y: hidden;
  padding: 0.25rem 0;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.3) transparent;
}

/* Custom scrollbar for webkit browsers */
.image-set-scroll::-webkit-scrollbar {
  height: 6px;
}

.image-set-scroll::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.1);
  border-radius: 3px;
}

.image-set-scroll::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.3);
  border-radius: 3px;
}

.image-set-scroll::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.5);
}

.view-more-button {
  flex-shrink: 0;
  width: 100px;
  height: 100px;
  background: transparent;
  border-radius: 8px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  padding: 0;
}

.view-more-button:hover {
  opacity: 0.8;
}

.view-more-text {
  color: #fff;
  text-align: center;
  line-height: 1.3;
  font-size: 0.9rem;
}

/* Responsive adjustments */
@media (max-width: 576px) {
  .view-more-button {
    width: 80px;
    height: 80px;
  }

  .view-more-text {
    font-size: 0.8rem;
  }
}

@media (max-width: 380px) {
  .view-more-button {
    width: 70px;
    height: 70px;
  }

  .view-more-text {
    font-size: 0.75rem;
  }
}
</style>
